import { schema } from 'normalizr';

import { processUser } from '../strategies/user';

import { networkSchema } from './network';
import { originNetworkSchema } from './originNetwork';

export const userSchema = new schema.Entity(
  'users',
  {
    networkId: networkSchema,
    originNetwork: originNetworkSchema,
  },
  {
    processStrategy: processUser,
  }
);
